import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { reinitate, redemptionTransaction } from "../../../store/actions";
import { CartItemsMap } from "../../../store/types";
import { CustomizedDialogsforReintitate } from "../customModal";
import { handleError } from "../../../utils/cart";

interface LocationState {
  fundCode: string;
  ihno: string;
}

export default function Redemption(props: any): JSX.Element {
  const { state } = useLocation<LocationState>();
  const dispatch = useDispatch();
  const { ihno } = state;

  // @ts-ignore
  const [payload, setPayload] = useState<CartItemsMap["RED"]>({});
  const [isOpen, setIsOpen] = useState(false);
  const [referenceNumber, setReferenctNumber] = useState("");

  useEffect(() => {
    (async function () {
      try {
        const response = await reinitate<"RED">(ihno)(dispatch);
        setPayload({
          ...response,
        });
      } catch (error) {
        alert(error);
      }
    })();
  }, [dispatch, ihno]);

  async function confirmTran() {
    try {
      const response = await redemptionTransaction({
        ...payload,
      })(dispatch);
      if (response) {
        const { ihno } = response;
        setReferenctNumber(ihno);
        setIsOpen(true);
      }
    } catch (error) {
      handleError(error);
    }
  }

  function goToDashboard() {
    props.history.push("/dashboard");
  }

  const {
    pan,
    mobile,
    email,
    fund,
    amount,
    units,
    arnCode,
    partial,
    folio,
    transactionType,
    schemeName,
    investorName,
  } = payload;

  const dataArr = [
    { label: "Investor Name", value: investorName },
    { label: "Email Id", value: email },
    { label: "Phone No", value: mobile },
    { label: "Folio", value: folio },
    {
      label: "Scheme",
      value: schemeName,
    },
    { label: "Redemption Type", value: !!partial ? "Partial" : "Full" },
    { label: "Redemption Mode", value: Number(units) ? "Units" : "Amount" },
    {
      label: "Redemption Value(INR/UNITS)",
      value: Number(units) ? units : amount,
    },
    { label: "ARN Code", value: arnCode },
    { label: "PAN", value: pan },
  ];
  return (
    <div
      className="table_border"
      style={{
        margin: "32px 48px",
        backgroundColor: "yellow",
      }}
    >
      <div
        className="container-fluid d-flex flex-column shadow-sm bg-white rounded"
        style={{
          minHeight: "240px",
          padding: "24px 36px",
        }}
      >
        <div className="d-flex justify-content-between align-items-center">
          <p className="text-primary mb-0" style={{ fontSize: 14 }}>
            Confirm re-initiation of transaction{" "}
            {transactionType ? `(${transactionType})` : ""}
          </p>
        </div>

        <div
          style={{ display: "flex", flexDirection: "row", flexWrap: "wrap" }}
        >
          {dataArr.map((ele, ind) => (
            <KeyValues label={ele.label} value={ele.value} index={ind} />
          ))}
        </div>

        <div
          className="d-flex justify-content-center mt-4 mb-6 MuiTableCell-root table-cell"
          style={{ border: "none", padding: "4px" }}
          onClick={confirmTran}
        >
          <div className="transaction-button mouse-pointer text-uppercase d-flex align-items-center">
            Confirm
          </div>
        </div>
      </div>
      <CustomizedDialogsforReintitate
        open={isOpen}
        closeModal={goToDashboard}
        componentName={"Redemption"}
        refNo={referenceNumber}
        confirmation={goToDashboard}
      />
    </div>
  );
}

function KeyValues({
  label,
  value,
  index,
}: {
  label: string;
  value: any;
  index: any;
}) {
  return (
    <div
      className={
        index % 2 === 0
          ? "digital-form-details-div"
          : "digital-form-details-next-div"
      }
    >
      <div>
        <div className={"digital-form-details-main-label"}>{label}</div>
        <div className={"digital-form-details-sub-label"}>{value}</div>
      </div>
    </div>
  );
}
